/* eslint-disable */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { currencyFormatter, displayTime } from './utils';
import State from '../app/store/state';
import {
    ActionCreators,
    AsyncTask,
    AsyncTaskRawStatus,
    AsyncTaskScheduler,
    AsyncTaskStatus,
    AsyncTasksTypes,
    mapAsyncTaskTypeToRequiredPostingAccessFeature,
    SapPoToAmountDialogType,
    SapPoToAmountEntry,
    SapPoToAmountRequestAction,
    Signature,
} from './asyncTasks';
import { AuthState, hasFeatureAccess } from '../login/auth';
import { hasAddAdditionalFileFeature, hasDownloadAdditionalFileFeature, hasDownloadFeature } from '../managers/manager';
import { RefreshSignaler } from './refresher';
import _ from 'lodash';
import { ActionCreators as ManagerActionCreators, ManagerNickName } from '../managers/managers';
import { canCancelWholeImport } from './validations';
import { scaleFloatToInteger } from './customMath';
import { stopPropagation } from './events';
import SapPoToAmountEntryStaticDialog from './SapPoToAmountEntryStaticDialog';
import { SESRequestsDialog } from './SESRequestsDialog';
import SapPoToAmountEntryEditableDialog from './SapPoToAmountEntryEditableDialog';
import { PredefinedCurrency } from '../app/appConfig';
import { isEmpty } from 'lodash';
import { DownloadAdditionalFileButton } from './DownloadStaticFileButton';
import moment from 'moment';
import { ConfirmationDialog } from './Dialogs';
import { ManagerPermission } from '../permission-profiles/permission';

const rawStatusesToStopRefresher = [AsyncTaskRawStatus.failed, AsyncTaskRawStatus.finished, AsyncTaskRawStatus.parked];

interface NextAction {
    style: any;
    text: string;
}

enum ImportActionTypes {
    SignLevel1 = 'Sign Level 1',
    SignLevel2 = 'Sign Level 2',
    PostCancellation = 'Post cancellation',
    ParkCancellation = 'Park cancellation',
    Post = 'Post',
    Cancel = 'Cancel',
    Reject = 'Reject',
}

export function getNextAction(row, auth, permission): NextAction[] {
    const canAuthorizeTask = hasFeatureAccess(auth, permission);

    const signatureOne = row.signatures.find((s) => s.requiredRole === ManagerPermission.beneficiariesSignLevelOne);
    const signatureTwo = row.signatures.find((s) => s.requiredRole === ManagerPermission.beneficiariesSignLevelTwo);

    const currentSignatureAction =
        signatureOne && !signatureOne.signedByManagerId
            ? {
                  signature: signatureOne,
                  permission: ManagerPermission.beneficiariesSignLevelOne,
                  text: ImportActionTypes.SignLevel1,
              }
            : signatureTwo && !signatureTwo.signedByManagerId
              ? {
                    signature: signatureTwo,
                    permission: ManagerPermission.beneficiariesSignLevelTwo,
                    text: ImportActionTypes.SignLevel2,
                }
              : null;

    const thisManagerParked = auth && auth.manager && row.createdByManagerId === auth.manager.id;

    const shouldDisplayPostForRow = (row) => {
        return row.status === AsyncTaskStatus.parked && canAuthorizeTask && !thisManagerParked;
    };

    const parkedImportCancellationText = thisManagerParked ? ImportActionTypes.Cancel : ImportActionTypes.Reject;

    const parkPostCancellationText = row.preCancelledAt
        ? ImportActionTypes.PostCancellation
        : ImportActionTypes.ParkCancellation;
    const signTask = () =>
        row.status === AsyncTaskStatus.toBeSigned &&
        currentSignatureAction &&
        validateSignaturesVisibility(row, row.signatures, auth, currentSignatureAction.permission);
    const nextAction: NextAction[] = [];
    if (shouldDisplayPostForRow(row)) {
        nextAction.push({
            style: { color: 'green', margin: 10 },
            text: ImportActionTypes.Post,
        });
    }
    if (
        ((thisManagerParked && row.status === AsyncTaskStatus.parked) || shouldDisplayPostForRow(row)) &&
        !row.parentId
    ) {
        nextAction.push({
            style: { color: 'red', margin: 10 },
            text: parkedImportCancellationText,
        });
    }
    if (canCancelWholeImport(auth, row, signTask())) {
        nextAction.push({
            style: { color: 'red', margin: 10 },
            text: parkPostCancellationText,
        });
    }
    if (signTask() && !row.preCancelledAt) {
        nextAction.push({
            style: { color: 'green', margin: 10 },
            text: currentSignatureAction.text,
        });
    }

    return nextAction;
}

interface DispatchProps {
    getAsyncTask: (type: string, id: string) => Promise<RefreshSignaler>;
    sapPoToAmountEntriesAction: (
        asyncTaskId: string,
        sapPoToAmountEntries: Array<SapPoToAmountEntry>,
        action: SapPoToAmountRequestAction
    ) => void;
    authorizeAsyncTask: (type: string, id: string) => void;
    downloadFile: (type: string, id: string, index?: number) => string;
    sign: (signatureId: string, managerId: string) => void;
    cancelTask: (type: string, id: string, isSubtask: boolean, parkPostAction: boolean) => void;
    loadManagersNickNames: () => void;
    clearDetails: () => void;
    handlePoDetailsFetchingError: (err) => void;
    cancelRunningTask: (type: string, id: string) => void;
    uploadAdditionalFile: (file: File, id: string, type: string, managerId: string) => any;
}

interface StateProps {
    auth: AuthState;
    data: AsyncTask;
    scheduler: AsyncTaskScheduler;
    entityName: string;
    entityUrl: string;
    taskKind: string;
    subTaskKind: string;
    error: string;
    managerNickNames: ManagerNickName[];
    currency: PredefinedCurrency;
    confirmNextAction: boolean;
}

interface OwnProps {
    params: { type: string; taskId: string };
}

type Props = OwnProps & DispatchProps & StateProps;

interface AsyncTaskDetailsViewState {
    actionExecuted: boolean;
    showSapPoEntryDialog: boolean;
    showSesRequestsDialog: boolean;
    task: AsyncTask;
    confirmDialogOptions: {
        showDialog: boolean;
        confirmAction: () => void;
    };
}

export class AsyncTaskDetailsView extends React.Component<Props, AsyncTaskDetailsViewState> {
    row: AsyncTask;
    private refresher?: RefreshSignaler;
    private featureAccess: ManagerPermission;

    constructor(props) {
        super(props);
        this.props.clearDetails();
        this.state = {
            actionExecuted: false,
            showSapPoEntryDialog: false,
            showSesRequestsDialog: false,
            task: null,
            confirmDialogOptions: {
                showDialog: false,
                confirmAction: () => {
                    return;
                },
            },
        };
    }

    markComponentAsActionExecuted() {
        this.setState({ actionExecuted: true });
    }

    resetComponentActionExecutionFlag() {
        this.setState({ actionExecuted: false });
    }

    async componentDidMount(): Promise<void> {
        await this.props.loadManagersNickNames();
        this.refresher = await this.props.getAsyncTask(this.props.params.type, this.props.params.taskId);
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (this.refresher && this.props.data && !rawStatusesToStopRefresher.includes(this.props.data.rawStatus)) {
            this.refresher.stop();
        }
        if (this.props.data !== nextProps.data) {
            this.resetComponentActionExecutionFlag();
        }
    }

    componentWillUnmount() {
        if (this.refresher) {
            this.refresher.stop();
        }
    }

    private async _authorizeTask(task: AsyncTask) {
        this.markComponentAsActionExecuted();
        await this.props.authorizeAsyncTask(task.type, task.id);
        this.refresher.refresh();
    }

    async sign(id: string) {
        await this.props.sign(id, this.props.auth.manager.id);
        this.refresher.refresh();
    }

    private async cancelTask(type: string, id: string, isSubtask: boolean, parkPostAction: boolean) {
        this.markComponentAsActionExecuted();
        await this.props.cancelTask(type, id, isSubtask, parkPostAction);
        this.refresher.refresh();
    }

    private cancelRunningExportTask(type: string, id: string) {
        this.markComponentAsActionExecuted();
        this.props.cancelRunningTask(type, id);
    }

    renderWarningsErrorRow(rowName: string, warningsErrorArrayToMap: Array<string>) {
        return (
            <tr>
                <th>{rowName}</th>
                <td>
                    {warningsErrorArrayToMap.map((element, index) => {
                        return !isEmpty(element) ? <p key={index}>{element}</p> : null;
                    })}
                    {rowName === 'Warnings' ? <p>Check report for details</p> : null}
                </td>
            </tr>
        );
    }

    renderStaticPoDetailsDialog(dialogType: SapPoToAmountDialogType, currency: PredefinedCurrency) {
        if (this.state.showSapPoEntryDialog) {
            return (
                <SapPoToAmountEntryStaticDialog
                    onClose={this.onClosePoDetailsDialog.bind(this)}
                    existingSapPoToAmountEntries={this.props.data.sapPoToAmountEntries}
                    onSubmit={this.onSapPoToAmountEntrySubmit.bind(this)}
                    dialogType={dialogType}
                    currency={currency}
                />
            );
        }
    }

    renderEditablePoDetailsDialog() {
        if (this.state.showSapPoEntryDialog) {
            return (
                <SapPoToAmountEntryEditableDialog
                    onClose={this.onClosePoDetailsDialog.bind(this)}
                    onSubmit={this.onSapPoToAmountEntrySubmit.bind(this)}
                    errorHandler={this.props.handlePoDetailsFetchingError}
                    currency={this.props.currency}
                    fileAmount={this.props.data.additionalInfo.rowSum as number}
                />
            );
        }
    }

    renderSesRequestsDialog() {
        if (this.state.showSesRequestsDialog) {
            return (
                <SESRequestsDialog
                    onClose={this.onCloseSesRequestsDialog.bind(this)}
                    sesRequests={this.props.data.sesRequests}
                    currency={this.props.currency}
                />
            );
        }
    }

    onClosePoDetailsDialog() {
        this.setState({ showSapPoEntryDialog: false });
    }

    onCloseSesRequestsDialog() {
        this.setState({ showSesRequestsDialog: false });
    }

    onSapPoToAmountEntrySubmit(sapPoToAmountEntries: Array<SapPoToAmountEntry>, action: SapPoToAmountRequestAction) {
        this.props.sapPoToAmountEntriesAction(this.props.data.id, sapPoToAmountEntries, action);
        this.onClosePoDetailsDialog();
    }

    renderManualPoParkedAtInfo = (managerNickNames: ManagerNickName[]) => {
        const { sapPoToAmount } = this.props.data;
        if (sapPoToAmount && sapPoToAmount.parkedAt && sapPoToAmount.parkedByManagerId) {
            return (
                <div>
                    Parked at {displayTime(sapPoToAmount.parkedAt)} by{' '}
                    {getManagerEmail(sapPoToAmount.parkedByManagerId, managerNickNames)}
                </div>
            );
        }
    };

    renderManualPoPostedAtInfo = (managerNickNames: ManagerNickName[]) => {
        const { sapPoToAmount } = this.props.data;
        if (sapPoToAmount && sapPoToAmount.authorizedAt && sapPoToAmount.authorizedByManagerId) {
            return (
                <div>
                    Posted at {displayTime(sapPoToAmount.authorizedAt)} by{' '}
                    {getManagerEmail(sapPoToAmount.authorizedByManagerId, managerNickNames)}
                </div>
            );
        }
    };

    renderManualPoCancelledAtInfo = (managerNickNames: ManagerNickName[]) => {
        const { sapPoToAmount } = this.props.data;
        if (sapPoToAmount && sapPoToAmount.cancelledAt && sapPoToAmount.cancelledByManagerId) {
            return (
                <div>
                    Rejected at {displayTime(sapPoToAmount.cancelledAt)} by{' '}
                    {getManagerEmail(sapPoToAmount.cancelledByManagerId, managerNickNames)}
                </div>
            );
        }
    };

    renderShowPoDialogActionButton = () => {
        const { sapPoToAmount, rawStatus } = this.props.data;

        if (
            rawStatus === AsyncTaskRawStatus.pendingManualPoEntryPark &&
            hasFeatureAccess(this.props.auth, ManagerPermission.beneficiariesEntitlementPark)
        ) {
            return this.renderPoDialogLink(SapPoToAmountDialogType.editable);
        } else if (
            rawStatus === AsyncTaskRawStatus.pendingManualPoEntryPost &&
            this.props.auth.manager &&
            sapPoToAmount.parkedByManagerId.toString() !== this.props.auth.manager.id.toString() &&
            hasFeatureAccess(this.props.auth, ManagerPermission.beneficiariesEntitlementVerify)
        ) {
            return this.renderPoDialogLink(SapPoToAmountDialogType.authorizable);
        } else if (sapPoToAmount && sapPoToAmount.parkedAt && !sapPoToAmount.cancelledAt) {
            return this.renderPoDialogLink(SapPoToAmountDialogType.display);
        } else {
            return '-';
        }
    };

    onCloseDialog = () => {
        this.setState({
            ...this.state,
            confirmDialogOptions: {
                showDialog: false,
                confirmAction: () => {
                    return;
                },
            },
        });
    };

    renderConfirmDialog = () => {
        const { confirmAction } = this.state.confirmDialogOptions;
        const message = `Have you read additional files ?`;

        const onConfirmHandler = () => {
            confirmAction();
            this.onCloseDialog();
        };

        return (
            <ConfirmationDialog
                message={message}
                title={`Confirm`}
                onConfirm={onConfirmHandler}
                onClose={this.onCloseDialog}
            />
        );
    };

    goNextActionHandler = (actionName: string, currentSignatureAction) => {
        const isAdditionalFile = this.props.data.additionalFiles.length > 0;

        const post = actionName === ImportActionTypes.Post;
        const cancelOrReject = actionName === ImportActionTypes.Cancel || actionName === ImportActionTypes.Reject;
        const parkOrPostCancellation =
            actionName === ImportActionTypes.ParkCancellation || actionName === ImportActionTypes.PostCancellation;
        const sign = actionName === ImportActionTypes.SignLevel1 || actionName === ImportActionTypes.SignLevel2;

        switch (true) {
            case post:
                if (this.props.confirmNextAction && isAdditionalFile) {
                    this.setState({
                        ...this.state,
                        confirmDialogOptions: {
                            showDialog: true,
                            confirmAction: this._authorizeTask.bind(this, this.props.data),
                        },
                    });
                } else {
                    this._authorizeTask(this.props.data);
                }
                break;
            case cancelOrReject:
                this.cancelTask(this.props.data.type, this.props.data.id, false, false);
                break;
            case parkOrPostCancellation:
                this.cancelTask(this.props.data.type, this.props.data.id, false, true);
                break;
            case sign:
                if (this.props.confirmNextAction && isAdditionalFile) {
                    this.setState({
                        ...this.state,
                        confirmDialogOptions: {
                            showDialog: true,
                            confirmAction: this.sign.bind(this, currentSignatureAction.signature.id),
                        },
                    });
                } else {
                    this.sign(currentSignatureAction.signature.id);
                }
        }
    };

    renderPoDialogLink(sapPoDialogType: SapPoToAmountDialogType) {
        return (
            <div>
                {
                    <span onClick={stopPropagation(() => {})}>
                        {sapPoDialogType === SapPoToAmountDialogType.editable
                            ? this.renderEditablePoDetailsDialog()
                            : this.renderStaticPoDetailsDialog(sapPoDialogType, this.props.currency)}
                        <a onClick={() => this.setState({ showSapPoEntryDialog: true })}>{sapPoDialogType}</a>
                    </span>
                }
            </div>
        );
    }

    renderSapPoToAmountElements = (managerNickNames: Array<ManagerNickName>) => {
        return (
            <div>
                {this.renderManualPoParkedAtInfo(managerNickNames)}
                {this.renderManualPoPostedAtInfo(managerNickNames)}
                {this.renderManualPoCancelledAtInfo(managerNickNames)}
                {this.renderShowPoDialogActionButton()}
            </div>
        );
    };

    renderSESDetails = () => {
        return (
            <div>
                {
                    <span onClick={stopPropagation(() => {})}>
                        {this.renderSesRequestsDialog()}
                        <a onClick={() => this.setState({ showSesRequestsDialog: true })}>Show SES requests</a>
                    </span>
                }
            </div>
        );
    };

    renderDownloadFile() {
        const { batchFileNames, errors, type } = this.props.data;
        if (this.props.data.fileExpired) {
            return <td>File Expired</td>;
        }
        if (errors && errors.length && type.includes('-export')) {
            return <td>Can not download file - export task finished with errors.</td>;
        }
        if (!batchFileNames) {
            return (
                <td>
                    <a onClick={() => this.props.downloadFile(this.props.params.type, this.props.params.taskId)}>
                        {this.props.data.fileName}
                    </a>
                    {this.props.error && <label>{this.props.error}</label>}
                    {/* TODO check why refresher doesn't work identically every time on details page */}
                </td>
            );
        } else {
            return (
                <td>
                    {this.props.data.zipFileExists ? (
                        <div>
                            <a
                                onClick={() =>
                                    this.props.downloadFile(this.props.params.type, this.props.params.taskId)
                                }
                            >
                                <b>{this.props.data.zipFileName}</b>
                            </a>
                        </div>
                    ) : (
                        <></>
                    )}
                    {batchFileNames.map((fileName, idx) => {
                        return (
                            <div>
                                <a
                                    onClick={() =>
                                        this.props.downloadFile(this.props.params.type, this.props.params.taskId, idx)
                                    }
                                >
                                    {fileName}
                                </a>
                                {this.props.error && <label>{this.props.error}</label>}
                            </div>
                        );
                    })}
                </td>
            );
        }
    }

    renderAdditionalFileUpload() {
        return (
            <tr>
                <th>Add Files</th>
                <td>
                    <button className="wfp-btn replaced-input-file" type="button">
                        <span>Add</span>
                        <input
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsx, text/csv, .csv, image/jpeg, .jpg, image/png, .png, application/pdf, .pdf, .docx"
                            name="data"
                            onChange={this.onAdditionalFilesUploadChange.bind(this)}
                            type="file"
                        />
                    </button>
                </td>
            </tr>
        );
    }

    renderResultFileRow() {
        // Show the first additional file separately for Mobile Devices import
        const isMobileDevicesImport = this.props.data && this.props.data.type === AsyncTasksTypes.MOBILE_DEVICES_IMPORT;
        const files = this.props.data?.additionalFiles || [];
        if (!isMobileDevicesImport || files.length === 0) {
            return null;
        }
        const firstFile = files[0];
        return (
            <tr>
                <th>Result File</th>
                <td>
                    <DownloadAdditionalFileButton fileKey={firstFile.key}>
                        {firstFile.fileName}
                    </DownloadAdditionalFileButton>
                </td>
            </tr>
        );
    }

    renderAdditionalFilesTable() {
        const managerNickNames = this.props.managerNickNames;
        const files = this.props.data.additionalFiles || [];
        // For Mobile Devices import, skip the first file (shown as Result File)
        const isMobileDevicesImport = this.props.data.type === AsyncTasksTypes.MOBILE_DEVICES_IMPORT;
        const listedFiles = isMobileDevicesImport ? files.slice(1) : files;
        if (listedFiles.length > 0) {
            return (
                <tr>
                    <th>Added Files</th>
                    <td>
                        <table>
                            <thead>
                                <tr>
                                    <th>File</th>
                                    <th>Added at</th>
                                    <th>Added by</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listedFiles.map((file) => (
                                    <tr key={file.key}>
                                        <td>
                                            <DownloadAdditionalFileButton fileKey={file.key}>
                                                {file.fileName}
                                            </DownloadAdditionalFileButton>
                                        </td>
                                        <td>{displayTime(file.createdAt)}</td>
                                        <td>{getManagerEmail(file.addedByManagerId, managerNickNames)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            );
        } else {
            return null;
        }
    }

    onAdditionalFilesUploadChange(event) {
        const file = event.target.files[0];
        if (file) {
            this.props
                .uploadAdditionalFile(
                    file,
                    this.props.params.taskId,
                    this.props.params.type,
                    this.props.auth.manager.id
                )
                .then(() => {
                    this.refresher.refresh();
                });
        }
    }

    render() {
        let signatures: Signature[] = [];
        let cancellationText = '';
        let preCancellationText = '';
        const titleForExport = this.props.data && this.props.data.type.includes('export') ? 'Export' : 'Import';
        let canDownload = false;
        if (this.props.data) {
            signatures = this.props.data.signatures;
            this.featureAccess = mapAsyncTaskTypeToRequiredPostingAccessFeature(this.props.data.type);
            preCancellationText = this.props.data.preCancelledByManager ? 'Park cancellation' : '';
            cancellationText =
                this.props.data.cancelledByManagerId === this.props.data.createdByManagerId ||
                this.props.data.preCancelledByManager
                    ? 'Cancelled'
                    : 'Rejected';
            if (this.props.auth && this.props.auth.manager) {
                canDownload = hasDownloadFeature(this.props.auth.manager, this.props.data.type);
            }
        }

        let signatureOne = null;
        let signatureTwo = null;
        let currentSignatureAction;
        if (signatures.length > 0) {
            signatureOne = signatures.find((s) => s.requiredRole === ManagerPermission.beneficiariesSignLevelOne);
            signatureTwo = signatures.find((s) => s.requiredRole === ManagerPermission.beneficiariesSignLevelTwo);

            currentSignatureAction =
                signatureOne && !signatureOne.signedByManagerId
                    ? {
                          signature: signatureOne,
                          permission: ManagerPermission.beneficiariesSignLevelOne,
                          text: 'Sign Level 1',
                      }
                    : signatureTwo && !signatureTwo.signedByManagerId
                      ? {
                            signature: signatureTwo,
                            permission: ManagerPermission.beneficiariesSignLevelTwo,
                            text: 'Sign Level 2',
                        }
                      : null;
        }

        const managerNickNames = this.props.managerNickNames;
        const level1Sign = signatureOne ? !!signatureOne.signedByManagerId : false;
        const level2Sign = signatureTwo ? !!signatureTwo.signedByManagerId : false;
        const intl = new Intl.NumberFormat(navigator.language);

        const isExport = this.props.data && this.props.data.type.includes('-export');

        const uploadReportChildrenWithoutDuplicates =
            this.props.data &&
            _.uniqBy(
                this.props.data.children.filter((child) =>
                    [
                        AsyncTasksTypes.UPLOAD_REPORT,
                        AsyncTasksTypes.SCOPE_UPLOAD_REPORT,
                        AsyncTasksTypes.EXPORT_REPORTS_SES_PARKING,
                    ].includes(child.type)
                ),
                (child) => child.fileName
            );

        const unfinishedChildTask =
            this.props.data &&
            this.props.data.children.find(
                (child) => !child.cancelledAt && !child.finishedAt && child.type === this.props.data.type
            );

        let canUploadAdditionalFile = false;
        let canDownloadAdditionalFile = false;
        if (this.props.data && this.props.data.type && this.props.auth && this.props.auth.manager) {
            canDownloadAdditionalFile =
                this.props.data.isAsyncTaskMain() && hasDownloadAdditionalFileFeature(this.props.auth.manager);
            canUploadAdditionalFile =
                this.props.data.isAsyncTaskMain() &&
                hasAddAdditionalFileFeature(this.props.auth.manager, this.props.data.type);
        }

        return (
            <div>
                {this.state.confirmDialogOptions.showDialog && this.renderConfirmDialog()}
                {this.props.entityName !== 'ActivityLogs' && this.props.entityName !== 'ReportsResult' && (
                    <nav className="wfp-breadcrumbs">
                        <ol className="breadcrumbs--wrapper">
                            <li className="breadcrumbs--item">
                                <Link to="/home" className="breadcrumbs--link">
                                    <span>Home</span>
                                </Link>
                            </li>
                            <li className="breadcrumbs--item">
                                <Link to={this.props.entityUrl} className="breadcrumbs--link">
                                    <span>{this.props.entityName}</span>
                                </Link>
                            </li>
                            <li className="breadcrumbs--item">
                                <Link
                                    to={
                                        this.props.entityUrl +
                                        '/' +
                                        (this.props.taskKind || '').toLowerCase() +
                                        '/' +
                                        (this.props.subTaskKind || '').toLowerCase()
                                    }
                                    className="breadcrumbs--link"
                                >
                                    <span>
                                        {this.props.taskKind.substring(0, 1).toUpperCase() +
                                            this.props.taskKind.substring(1) +
                                            ' ' +
                                            this.props.subTaskKind.substring(0, 1).toUpperCase() +
                                            this.props.subTaskKind.substring(1)}
                                    </span>
                                </Link>
                            </li>
                            {this.props.data && (
                                <li className="breadcrumbs--item">
                                    <span className="breadcrumbs--last">{`Show Details of ${this.props.taskKind} "${this.props.data.id}"`}</span>
                                </li>
                            )}
                        </ol>
                    </nav>
                )}
                <table className="wfp-table mt4 table-hover">
                    {this.props.data && (
                        <tbody>
                            <tr>
                                <th>ID</th>
                                <td>{this.props.data.id}</td>
                            </tr>
                            {this.props.data.description && (
                                <tr>
                                    <th>Description</th>
                                    <td>{this.props.data.description}</td>
                                </tr>
                            )}
                            <tr>
                                <th>{titleForExport} Status</th>
                                <td>{!this.state.actionExecuted && <div>{this.props.data.status}</div>}</td>
                            </tr>
                            <tr>
                                <th>Next Actions</th>
                                <td>
                                    {!this.state.actionExecuted && (
                                        <div>
                                            {getNextAction(this.props.data, this.props.auth, this.featureAccess).map(
                                                (action) => {
                                                    return (
                                                        <a
                                                            className={'ml-0 mr-5'}
                                                            key={action.text}
                                                            style={action.style}
                                                            onClick={() =>
                                                                this.goNextActionHandler(
                                                                    action.text,
                                                                    currentSignatureAction
                                                                )
                                                            }
                                                        >
                                                            {action.text}
                                                        </a>
                                                    );
                                                }
                                            )}
                                        </div>
                                    )}
                                    {isExport &&
                                        (this.props.data.status === AsyncTaskStatus.created ||
                                            this.props.data.status === AsyncTaskStatus.inProgress) && (
                                            <a
                                                onClick={this.cancelRunningExportTask.bind(
                                                    this,
                                                    this.props.data.type,
                                                    this.props.data.id
                                                )}
                                            >
                                                Cancel
                                            </a>
                                        )}
                                </td>
                            </tr>
                            {this.props.data.progress &&
                                this.props.data.rawStatus === AsyncTaskRawStatus.inProgress &&
                                this.props.data.progress.toString() !== '1' && (
                                    <tr>
                                        <th>{titleForExport}ing Progress</th>
                                        <td>
                                            {!this.state.actionExecuted && (
                                                <div>
                                                    {` (${scaleFloatToInteger(
                                                        parseFloat(this.props.data.progress),
                                                        2
                                                    )}% – ${this.props.data.additionalInfo.lastBatchIndex}/${
                                                        this.props.data.additionalInfo.numberOfBatches
                                                    })`}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            {this.props.data.fileName && canDownload && (
                                <tr>
                                    <th>Download File</th>
                                    {this.renderDownloadFile()}
                                </tr>
                            )}
                            {!this.props.data.isAsyncTaskErroneous() && this.props.data.additionalInfo && (
                                <tr>
                                    <th>
                                        {this.props.data.parentId && !this.props.data.payload
                                            ? 'Info after processing'
                                            : 'File info'}
                                    </th>
                                    <td>
                                        <div>
                                            {this.props.data.additionalInfo.lastBatchIndex !== 0 &&
                                                this.props.data.additionalInfo.lastBatchIndex &&
                                                `Batch: ${this.props.data.additionalInfo.lastBatchIndex}/${this.props.data.additionalInfo.numberOfBatches}`}
                                        </div>
                                        <div>
                                            {this.props.data.additionalInfo.rowCount &&
                                                `Total file row count: ${intl.format(
                                                    this.props.data.additionalInfo.rowCount as number
                                                )}`}{' '}
                                            <br />
                                            {(this.props.data.additionalInfo.rowSum as number) > 0 &&
                                                `Total file amount: ${currencyFormatter(this.props.currency).format(
                                                    this.props.data.additionalInfo.rowSum as number
                                                )}`}
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {isExport ||
                                (!moment(this.props.data.createdAt).isSame(this.props.data.parkedAt, 'seconds') && (
                                    <tr>
                                        <th>{isExport ? 'Requested' : 'Created'}</th>
                                        <td>
                                            {displayTime(this.props.data.createdAt)}
                                            {this.props.data.type === AsyncTasksTypes.SCOPE_ANNOUNCEMENTS ? (
                                                <div>by SCOPE</div>
                                            ) : (
                                                this.props.data.createdByManagerId && (
                                                    <div>by {this.props.data.createdByManager.name}</div>
                                                )
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            {!isExport && (
                                <tr>
                                    <th>Parked</th>
                                    <td>
                                        {displayTime(this.props.data.parkedAt)}
                                        {this.props.data.type === AsyncTasksTypes.SCOPE_ANNOUNCEMENTS ? (
                                            <div>by SCOPE</div>
                                        ) : (
                                            this.props.data.createdByManagerId && (
                                                <div>by {this.props.data.createdByManager.name}</div>
                                            )
                                        )}
                                    </td>
                                </tr>
                            )}
                            {this.props.data.type !== AsyncTasksTypes.SCOPE_ANNOUNCEMENTS && !isExport && (
                                <tr>
                                    <th>Posted</th>
                                    <td>
                                        {displayTime(this.props.data.authorizedAt)}
                                        {this.props.data.type === AsyncTasksTypes.SCOPE_ANNOUNCEMENTS ? (
                                            <div>by SCOPE</div>
                                        ) : (
                                            this.props.data.authorizedByManager && (
                                                <div>by {this.props.data.authorizedByManager.name}</div>
                                            )
                                        )}
                                    </td>
                                </tr>
                            )}
                            {this.props.data.preCancelledAt && (
                                <tr>
                                    <th>{preCancellationText}</th>
                                    <td>
                                        {displayTime(this.props.data.preCancelledAt)}
                                        <div>
                                            by{' '}
                                            {!this.props.data.preCancelledByManager
                                                ? 'System'
                                                : this.props.data.preCancelledByManager.name}
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {this.props.data.cancelledAt && (
                                <tr>
                                    <th>{cancellationText}</th>
                                    <td>
                                        {displayTime(this.props.data.cancelledAt)}
                                        <div>
                                            by{' '}
                                            {!this.props.data.cancelledByManager
                                                ? 'System'
                                                : this.props.data.cancelledByManager.name}
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {!this.props.data.parentId && this.props.data.getFinancialProcessor() && (
                                <tr>
                                    <th>SAP PO Details</th>
                                    <td>{this.renderSapPoToAmountElements(managerNickNames)}</td>
                                </tr>
                            )}
                            {!this.props.data.parentId &&
                                this.props.data.sesRequests &&
                                this.props.data.sesRequests.length > 0 && (
                                    <tr>
                                        <th>SAP SES Details</th>
                                        <td>{this.renderSESDetails()}</td>
                                    </tr>
                                )}
                            {!this.props.data.parentId && signatures.length > 0 && (
                                <tr>
                                    <th>Level 1 signature</th>
                                    <td>
                                        {level1Sign ? (
                                            <div>
                                                Signed at {displayTime(signatureOne.signedAt)} by{' '}
                                                {getManagerEmail(signatureOne.signedByManagerId, managerNickNames)}
                                            </div>
                                        ) : (
                                            '-'
                                        )}
                                    </td>
                                </tr>
                            )}
                            {!this.props.data.parentId && signatures.length > 0 && level1Sign && (
                                <tr>
                                    <th>Level 2 signature</th>
                                    <td>
                                        {level2Sign ? (
                                            <div>
                                                Signed at {displayTime(signatureTwo.signedAt)} by{' '}
                                                {getManagerEmail(signatureTwo.signedByManagerId, managerNickNames)}
                                            </div>
                                        ) : (
                                            '-'
                                        )}
                                    </td>
                                </tr>
                            )}
                            {this.props.data.additionalInfo && this.props.data.additionalInfo.validFrom && (
                                <tr>
                                    <th>Valid from</th>
                                    <td>
                                        {displayTime(
                                            moment(this.props.data.additionalInfo.validFrom, 'YYYYMMDD').toDate()
                                        )}
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <th>Started</th>
                                <td>{displayTime(this.props.data.startedAt)}</td>
                            </tr>
                            <tr>
                                <th>Finished</th>
                                <td>{displayTime(this.props.data.finishedAt)}</td>
                            </tr>
                            {this.props.data.payload && this.props.data.payload.balancesCalculationTime && (
                                <tr>
                                    <th>Data as of</th>
                                    <td>{displayTime(this.props.data.payload.balancesCalculationTime as string)}</td>
                                </tr>
                            )}
                            {canDownload &&
                                uploadReportChildrenWithoutDuplicates &&
                                uploadReportChildrenWithoutDuplicates.length > 0 &&
                                !unfinishedChildTask && (
                                    <tr>
                                        <th>Upload Reports</th>
                                        <td>
                                            {uploadReportChildrenWithoutDuplicates.map((uploadReportChild, index) => {
                                                return (
                                                    <p key={uploadReportChild.toString() + index}>
                                                        {uploadReportChild.fileExpired &&
                                                            `Upload Report ${uploadReportChild.fileName} is expired`}
                                                        {uploadReportChild.errors &&
                                                            'Errors in upload report creation occurred'}
                                                        {!uploadReportChild.errors && (
                                                            <a
                                                                onClick={() =>
                                                                    this.props.downloadFile(
                                                                        uploadReportChild.type,
                                                                        uploadReportChild.id
                                                                    )
                                                                }
                                                            >
                                                                {uploadReportChild.fileName}
                                                            </a>
                                                        )}
                                                    </p>
                                                );
                                            })}
                                        </td>
                                    </tr>
                                )}
                            {this.props.data.isAsyncTaskErroneous() &&
                                this.renderWarningsErrorRow('Errors', this.props.data.errors)}
                            {this.props.data.warnings &&
                                this.props.data.warnings.length > 0 &&
                                this.renderWarningsErrorRow('Warnings', this.props.data.warnings)}
                            {this.props.data.dryRunErrors &&
                                this.props.data.dryRunErrors.length > 0 &&
                                this.renderWarningsErrorRow('Pre validation warnings', this.props.data.dryRunErrors)}
                            {canUploadAdditionalFile && this.renderAdditionalFileUpload()}
                            {canDownloadAdditionalFile && this.renderResultFileRow()}
                            {canDownloadAdditionalFile && this.renderAdditionalFilesTable()}
                        </tbody>
                    )}
                </table>
            </div>
        );
    }
}

function validateSignaturesVisibility(
    asyncTask: AsyncTask,
    signatures: Signature[],
    authState: AuthState,
    requiredFeatureAccess: ManagerPermission
): boolean {
    if (
        !hasFeatureAccess(authState, requiredFeatureAccess) ||
        asyncTask.isAsyncTaskErroneous() ||
        asyncTask.finishedAt
    ) {
        return false;
    }

    if (requiredFeatureAccess === ManagerPermission.beneficiariesSignLevelTwo) {
        const firstSign = signatures.find((s) => s.requiredRole === ManagerPermission.beneficiariesSignLevelOne);
        if (firstSign.signedByManagerId.toString() === authState.manager.id) {
            return false;
        }
    }
    if (asyncTask.type === AsyncTasksTypes.IMPORT_BENEFICIARIES) {
        return !!asyncTask.authorizedByManager;
    }

    if (asyncTask.type === AsyncTasksTypes.SCOPE_ANNOUNCEMENTS) {
        return !!asyncTask.parkedAt;
    } else {
        return false;
    }
}

function getManagerEmail(managerId: number, managersNickName: ManagerNickName[]) {
    const manager = managerId ? managersNickName.find((name) => name.id === managerId.toString()) : null;
    if (manager) {
        return manager.email;
    }
    return managerId;
}

function determineEntityData(entity: string): { entityName: string; entityUrl: string } {
    switch (entity) {
        case 'beneficiary':
            return { entityName: 'Beneficiaries', entityUrl: '/beneficiaries' };
        case 'scope':
            return { entityName: 'Beneficiaries', entityUrl: '/beneficiaries' };
        case 'vendor':
            return { entityName: 'Vendors', entityUrl: '/vendors' };
        case 'transaction':
            return { entityName: 'Transactions', entityUrl: '/transactions' };
        case 'reports':
            return { entityName: 'ReportsResult', entityUrl: null };
        case 'activity':
            return { entityName: 'ActivityLogs', entityUrl: null };
        case 'users':
            return { entityName: 'Admins', entityUrl: '/admin' };
        case 'alternative':
            return { entityName: 'Beneficiaries', entityUrl: '/beneficiaries' };
        case 'remove':
            return { entityName: 'Beneficiaries', entityUrl: '/beneficiaries' };
        case 'alignment':
            return { entityName: 'Beneficiaries', entityUrl: '/beneficiaries' };
        case 'mobileDevices':
            return { entityName: 'Mobile Devices', entityUrl: '/mobile-devices' };
    }
}

function mapStateToProps(state: State): StateProps {
    let subTaskKind = '';
    const splitTypeString = ((state.asyncTasks.details || { type: '' }).type || '').split('-', 3);
    let [entity, taskKind = ''] = splitTypeString;

    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.BENEFICIARY_ZEROING_BLOCK) {
        subTaskKind = splitTypeString[2];
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.SCOPE_ANNOUNCEMENTS) {
        taskKind = 'Import';
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type.includes('export')) {
        taskKind = 'Download';
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.EXPORT_BENEFICIARIES_PINS) {
        taskKind = 'Export-Pins';
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.IMPORT_ALTERNATIVE_COLLECTORS) {
        taskKind = 'Import';
        subTaskKind = 'Alternative-Collectors';
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.REMOVE_ALTERNATIVE_COLLECTORS) {
        taskKind = 'Import';
        subTaskKind = 'Remove-Alternative-Collectors';
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.SAP_SES_PARK_REQUESTS) {
        entity = 'beneficiary';
        taskKind = 'Import';
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.SAP_SES_PARK_ALIGNMENT_REQUESTS) {
        entity = 'alignment';
        taskKind = 'Import';
    }
    if (state.asyncTasks.details && state.asyncTasks.details.type === AsyncTasksTypes.MOBILE_DEVICES_IMPORT) {
        entity = 'mobileDevices';
        taskKind = 'Import';
    }

    const { entityName = null, entityUrl = null } = determineEntityData(entity) || {};

    return {
        data: state.asyncTasks.details,
        scheduler: state.asyncTasks.schedulerDetails,
        entityName,
        entityUrl,
        taskKind,
        subTaskKind,
        error: state.asyncTasks.error,
        auth: state.auth,
        managerNickNames: state.managers.managerNickNameList,
        currency: state.appConfig.entitlementCurrencyConfig,
        confirmNextAction: true,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getAsyncTask: bindActionCreators(ActionCreators.getAsyncTask, dispatch),
        sapPoToAmountEntriesAction: bindActionCreators(ActionCreators.sapPoToAmountEntriesAction, dispatch),
        authorizeAsyncTask: bindActionCreators(ActionCreators.authorizeAsyncTask, dispatch),
        downloadFile: bindActionCreators(ActionCreators.downloadFile, dispatch),
        sign: bindActionCreators(ActionCreators.sign, dispatch),
        cancelTask: bindActionCreators(ActionCreators.cancelTask, dispatch),
        loadManagersNickNames: bindActionCreators(ManagerActionCreators.loadManagersNickNames, dispatch),
        clearDetails: bindActionCreators(ActionCreators.clearDetails, dispatch),
        handlePoDetailsFetchingError: bindActionCreators(ActionCreators.handlePoDetailsFetchingError, dispatch),
        cancelRunningTask: bindActionCreators(ActionCreators.cancelRunningTask, dispatch),
        uploadAdditionalFile: bindActionCreators(ActionCreators.uploadAdditionalFile, dispatch),
    };
}

export default connect<StateProps, DispatchProps, any>(
    mapStateToProps,
    mapDispatchToProps as any
)(AsyncTaskDetailsView);
